import React, { useState } from 'react';
import { withRouter } from 'react-router';
import { useSelector } from 'react-redux';
import { CollapseIcon } from '../../icons/CollapseIcon';
import { Flex } from '../../components/Flex';
import { Sider } from '../../components/Layout';
import { NavigationItem } from './NavigationItem';
import { NavigationMenu } from './NavigationMenu';


const Navigation = withRouter(({ location }) => {
    const { grants } = useSelector(state => state.user);
    const [ collapsed, setCollapsed ] = useState(true);

    let tab = null, parts = location.pathname.split('/');
    if (parts.length > 1 && parts[1]) tab = parts[1];
    if (!grants.isAdmin && tab === "organisations") tab = "organisation";

    return(
        tab !== "login" &&
        <Sider collapsed={collapsed}>
            <NavigationMenu selected={tab} collapsed={collapsed} {...grants} />
            <Flex align="center" padding={{ left: "20px", right: "20px" }} gap={{ right: 12 }} key="collapse" cursor="pointer" position="relative" onClick={() => setCollapsed(!collapsed)}>
                <NavigationItem
                    collapsed={collapsed}
                    item={{
                        key: 'collapse',
                        title: "collapse menu",
                        icon: <CollapseIcon rotate={collapsed ? 180 : 0} />,
                        tooltip: "expand menu"
                    }}
                />
            </Flex>
        </Sider>
    );
});

export { Navigation };